import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { Enpoints } from "../../contants/Endpoints";
import { WordpressOmroep } from "../../types/wordpressTypes/wordpressOmroep";
import { primeMediaUrlsFromEntities } from "./mediaUrls";

export async function getAllOmroepen() {
  const result = await axios.get<WordpressOmroep[]>(`${import.meta.env.VITE_API_URL}/wp-json/wp/v2/${Enpoints.TV_CHANNEL}`);
  primeMediaUrlsFromEntities(result.data);
  return result;
}

export function useGetAllOmroepen(enabled: boolean = true) {
  return useQuery({
    queryKey: [Enpoints.TV_CHANNEL],
    queryFn: getAllOmroepen,
    enabled
  });
}
